// Provisional (Phase 1) copy. Final product narratives arrive in Phase 3.

export const PRODUCT_IDS = ["briefcase", "forma", "lumen"];

export const PRODUCTS = {
  briefcase: {
    id: "briefcase", name: "Briefcase", path: "/products/briefcase", theme: "t-briefcase", index: "P1",
    activity: "Leading shared work",
    responsibilityShort: "Direction, connected participation, consequential return",
    tagline: "Organized around leading shared work: setting direction, connecting the people who carry it, and returning what happens to those responsible.",
    placeholder: "Briefcase product experience",
    movements: [
      { id: "leadership", label: "Leadership", text: "The person or group responsible for shared work, and what they are answerable for." },
      { id: "direction", label: "Direction", text: "Where the work is meant to go, stated so that others can act on it." },
      { id: "participation", label: "Connected participation", text: "The people who carry the work, connected to the direction and to one another." },
      { id: "return", label: "Consequential return", text: "What actually happens returns to those responsible, so direction can be reconsidered." },
    ],
  },
  forma: {
    id: "forma", name: "Forma", path: "/products/forma", theme: "t-forma", index: "P2",
    activity: "Living and thinking with a personal intelligence",
    responsibilityShort: "Personally formed intelligence, continuing personal environment",
    headline: "Turn general AI into your AI.",
    tagline: "Organized around personally formed intelligence and a continuing personal environment.",
    placeholder: "Forma workstation and Home experience",
    mechanism: [
      { label: "General AI", text: "A capable, general intelligence that begins knowing nothing particular about you." },
      { label: "Formation", text: "The Formation mechanism shapes that intelligence around a particular person." },
      { label: "Your AI", text: "An intelligence formed around you, held within a continuing personal environment." },
    ],
    environment: [
      { id: "home", label: "Home", text: "The point of return within the personal environment.", placeholder: "Forma Home experience" },
      { id: "continuity", label: "Continuity", text: "What carries forward from one occasion to the next.", placeholder: "Forma Continuity experience" },
      { id: "my-world", label: "My World", text: "The people, places, and commitments of a person's life.", placeholder: "Forma My World experience" },
      { id: "thought-world", label: "Thought World", text: "The ideas and lines of thought a person is developing.", placeholder: "Forma Thought World experience" },
      { id: "workstation", label: "Fixed-case workstation", text: "A dedicated workstation for Forma. Details to be supplied in Phase 3.", placeholder: "Forma fixed-case workstation" },
    ],
    integrationNote: "The original Formation mechanism and the continuing personal environment are presented here as one integrated direction.",
  },
  lumen: {
    id: "lumen", name: "Lumen", path: "/products/lumen", theme: "t-lumen", index: "P3",
    activity: "Learning together in classrooms",
    responsibilityShort: "Student development, classroom participation, continuity of learning",
    tagline: "Organized around student development, classroom participation, collective understanding, and the continuity of learning.",
    placeholder: "Lumen classroom and learning environment",
    scales: [
      { id: "continuity", index: "04", label: "Continuity of learning", text: "How learning carries forward over time rather than restarting each term." },
      { id: "collective", index: "03", label: "Collective understanding", text: "What a class comes to understand together." },
      { id: "classroom", index: "02", label: "Classroom participation", text: "How students take part in the life of a classroom." },
      { id: "student", index: "01", label: "Student development", text: "Each student's development, followed as their own." },
    ],
  },
};
